<template>
  <v-app>
    <v-container>
      <v-layout>
        <div class="col-xs-12">
          <h3>This page no longer available!</h3>
          <br />
        </div>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    getCSSwith(key) {
      return this.$store.state.svrCSS[key]
    }
  },
  destroyed() {
    console.log('destroy')
  }
}
</script>
